"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderAttributesSchema = exports.OrderStatuses = void 0;
const zod_1 = require("zod");
const common_1 = require("../../helpers/common");
exports.OrderStatuses = {
    DRAFT: 'draft',
    UPDATED: 'updated',
    CREATED: 'created',
    AWAITING_PAYMENT: 'awaiting_payment',
    AWAITING_PROCESS: 'awaiting_process',
    ORDER_PROCESSED: 'order_processed',
    ORDER_SENT: 'order_sent',
    ACTIVE: 'active',
    RETURN_PROCESS: 'return_process',
    FULFILLED: 'fulfilled',
    CANCELED: 'canceled',
};
exports.OrderAttributesSchema = zod_1.z.object({
    id: zod_1.z.number(),
    status: zod_1.z.nativeEnum(exports.OrderStatuses),
    invoiceId: zod_1.z.number().nullable().optional(),
    customerId: zod_1.z.number(),
    cartId: zod_1.z.number().nullable().nullable().optional(),
    couponId: zod_1.z.number().nullable().optional(),
    deliveryAddressId: zod_1.z.number(),
    pickupAddressId: zod_1.z.number(),
    awaitingPaymentUntil: (0, common_1.zodDateString)(true),
    awaitingConfirmationUntil: (0, common_1.zodDateString)(true),
    createdAt: (0, common_1.zodDateString)(true),
});
//# sourceMappingURL=order.js.map